export const imageFormats = ['apng','avif','gif','jpg','jpeg','jfif','pjpeg','pjp','png','svg','webp'];
export const videoFormats = ['mp4','mov','wmv','flv','avi','avchd','webm','mkv'];

export const getFileFormat = (fileUrl) => fileUrl && fileUrl.indexOf('.') > 0 ? fileUrl.slice(fileUrl.lastIndexOf('.') + 1) : null;

export const isVideo = (fileFormat) => videoFormats.includes(fileFormat);
export const isImage = (fileFormat) => imageFormats.includes(fileFormat);